import React from 'react'
import { Option } from 'types/global'
import styles from './option-list.module.scss'
import cx from 'classnames'

interface Props<TValue = string> {
  name: string
  options: Option<TValue>[]
  selectedValue?: TValue
  setSelectedValue: (value: TValue) => void
}

const selectedTick = (
  <svg xmlns='http://www.w3.org/2000/svg' width='26' height='26' fill='none' viewBox='0 0 26 26'>
    <path
      stroke='#737680'
      strokeLinecap='round'
      strokeWidth='1.7'
      d='M7.8 13.54l3.16 3.283c.04.041.106.04.145-.002L18.2 9.1'
    />
  </svg>
)

const OptionList = <TValue,>({ options, name, selectedValue, setSelectedValue }: Props<TValue>) => {
  return (
    <fieldset className={cx(styles.group)}>
      {options.map(({ label, value }) => {
        const optionId = `option-${name}-${value}`
        const isSelected = value === selectedValue
        return (
          <label key={optionId} htmlFor={optionId} className={cx(styles.option)}>
            <input
              type='radio'
              name={name}
              id={optionId}
              checked={isSelected}
              className={cx(styles.screenReaderOnly)}
              onChange={e => {
                setSelectedValue(value)
              }}
            />
            {label}
            {isSelected && selectedTick}
          </label>
        )
      })}
    </fieldset>
  )
}

export default OptionList
